import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import AccessibilityNewIcon from '@material-ui/icons/AccessibilityNew';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Scannable } from 'react-scannable';

export class SignLanguageButton extends Component {
  static propTypes = {
    hidden: PropTypes.bool,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
    increaseOutputButtons: PropTypes.bool
  };

  render() {
    const { hidden, loading, increaseOutputButtons, onClick, ...other } =
      this.props;

    return (
      <Scannable disabled={hidden}>
        <IconButton
          aria-label="Sign Language"
          className={
            increaseOutputButtons ? 'Output__button__lg' : 'Output__button__sm'
          }
          onClick={onClick}
          disabled={loading || hidden}
          {...other}
        >
          {loading ? (
            <CircularProgress
              size={increaseOutputButtons ? 40 : 24}
              color="inherit"
            />
          ) : (
            <AccessibilityNewIcon
              className={
                increaseOutputButtons ? 'Output__icon__lg' : 'Output__icon__sm'
              }
            />
          )}
        </IconButton>
      </Scannable>
    );
  }
}

export default SignLanguageButton;
